import { Search, X } from 'lucide-react';
import { useT } from '../../i18n';
import { cn } from '../../lib/cn';
import { Input } from './input';

export interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name for the input. */
  label: string;
  className?: string;
  /** Takes the focus when shown — the search is the whole point of a picker dialog. */
  autoFocus?: boolean;
}

/**
 * The search box of a toolbar: it takes the spare width so the filters beside
 * it can stay small, and clears itself without the user selecting the text.
 */
export const SearchField = ({
  value,
  onChange,
  placeholder,
  label,
  className,
  autoFocus,
}: SearchFieldProps) => {
  const { t } = useT();

  return (
    <div className={cn('relative min-w-0 flex-1', className)}>
      <Search
        className="pointer-events-none absolute left-2.5 top-1/2 size-3.5 -translate-y-1/2 text-ink-subtle"
        aria-hidden="true"
      />
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={label}
        autoFocus={autoFocus}
        className={cn('pl-8', value ? 'pr-8' : undefined)}
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={t('common.clearSearch')}
          className="absolute right-1.5 top-1/2 grid size-6 -translate-y-1/2 place-items-center rounded text-ink-subtle transition-colors hover:bg-sunken hover:text-ink"
        >
          <X className="size-3.5" />
        </button>
      ) : null}
    </div>
  );
};
